import { useSelector } from 'react-redux';
import moment from 'moment';
import { FILE_BASE_URL } from './services/apiCollections';
import crypto from 'crypto';
import { Buffer } from 'buffer';
import { toast } from 'react-toastify';

export const GetToken = () => {
  const Authorization = useSelector(state => state.auth.token);
  if (Authorization && Authorization.length > 0) return Authorization;
  else return false;
};

export const getImageUrl = (imagePath, image, imageType) => {
  return FILE_BASE_URL() + imagePath + '/' + image + '.' + imageType;
};

export const findAge = birthday => {
  const a = moment();
  const b = moment(birthday);
  return moment.duration(a.diff(b)).years();
};

export const getRandomValueInRange = (startValue, endValue) => Math.floor(Math.random() * (startValue - endValue + 1) + endValue);

export const isFirefox = typeof InstallTrigger !== 'undefined';

export const formatToGermanCurrency = number => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number);
export const encrypt = text => {
  const iv = generateIV(16);
  const cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(process.env.REACT_APP_TMP), Buffer.from(iv), iv);
  let encrypted = cipher.update(text);
  encrypted = Buffer.concat([encrypted, cipher.final()]);
  return { iv: iv, encryptedData: encrypted.toString('hex') };
};

export const decrypt = text => {
  const iv = Buffer.from(text.iv);
  const encryptedText = Buffer.from(text.encryptedData, 'hex');
  const decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(process.env.REACT_APP_TMP), iv);
  let decrypted = decipher.update(encryptedText);
  decrypted = Buffer.concat([decrypted, decipher.final()]);
  return decrypted.toString();
};

function generateIV(length) {
  let result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// Flag to prevent duplicate refresh token error toasts
let isRefreshTokenErrorToastShown = false;

export const toastify = ( type, message ) => {
  // Prevent duplicate refresh token error toasts
  if (type === 'error' && message === "No refresh access found. Please login again.") {
    if (isRefreshTokenErrorToastShown) {
      return;
    }
    isRefreshTokenErrorToastShown = true;
    // Reset flag after toast auto-closes (3000ms)
    setTimeout(() => {
      isRefreshTokenErrorToastShown = false;
    }, 3000);
  }

  switch (type) {
    case 'success':
      return toast.success(message, {
        className: "toastify-custom",
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    case 'warn':
      return toast.warn(message, {
        className: "toastify-custom",
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    case 'info':
      return toast.info(message, {
        className: "toastify-custom",
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    case 'error':
      return toast.error(message, {
        className: "toastify-custom",
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    default:
      break;
  }
}


export const truncateText = (text, maxLength = 30) => {
  if (typeof text !== "string") return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};
